import React from 'react';
import OnboardingLayout from 'nallian-shared-ui/lib/layout/OnboardingLayout';
import { Flex } from 'nallian-shared-ui/lib/components';
import InviteOverview from './steps/InviteOverview';

const Invitation = () => (
  <OnboardingLayout>
    <Flex fluid direction="column" margin="50px 0 0">
      <InviteOverview />
    </Flex>
  </OnboardingLayout>
);

export default Invitation;
